<div
  class="change-status">
  <h2
    *ngIf="selectedUser.length <= 1 && (groupStatus === 'unlocked' || userStatus)"
    class="headline">{{'USER_LIST.MODAL.BLOCKED_USER' | translate}}</h2>
  <h2
    *ngIf="selectedUser.length > 1 && groupStatus === 'unlocked'"
    class="headline">{{'USER_LIST.MODAL.BLOCKED_USERS' | translate}}
  </h2>

  <h2
    *ngIf="selectedUser.length <= 1 && (groupStatus === 'blocked' || !userStatus)"
    class="headline">{{'USER_LIST.MODAL.UNBLOCKED_USER' | translate}}</h2>
  <h2
    *ngIf="selectedUser.length > 1 && groupStatus === 'blocked'"
    class="headline">{{'USER_LIST.MODAL.UNBLOCKED_USERS' | translate}}
  </h2>


  <p
    *ngIf="selectedUser.length <= 1 && (groupStatus === 'unlocked' || userStatus)"
    class="description">{{'USER_LIST.MODAL.BLOCKED_DESCRIPTION_1' | translate}}</p>
  <p
    *ngIf="selectedUser.length > 1 && groupStatus === 'unlocked'"
    class="description">{{'USER_LIST.MODAL.BLOCKED_DESCRIPTION_2' | translate}}</p>

  <p
    *ngIf="selectedUser.length <= 1 && (groupStatus === 'blocked' || !userStatus)"
    class="description">{{'USER_LIST.MODAL.UNBLOCKED_DESCRIPTION_1' | translate}}</p>
  <p
    *ngIf="selectedUser.length > 1 && groupStatus === 'blocked'"
    class="description">{{'USER_LIST.MODAL.UNBLOCKED_DESCRIPTION_2' | translate}}</p>

  <h3
    *ngIf="selectedUser.length <= 1"
    class="subtitle">{{userName}}</h3>

  <h3
    *ngIf="selectedUser.length > 1"
    class="subtitle">{{'USER_LIST.MODAL.STATUS_USER_COUNT' | translate}}: {{selectedUser.length}}</h3>
  <div class="btn-block">
    <button
      (click)="changeStatusUser()"
      *ngIf="(groupStatus === 'unlocked' || (userStatus && selectedUser.length === 0))"
      class="btn btn-accent">{{'USER_LIST.MODAL.BLOCKED_BUTTON' | translate}}</button>
    <button
      (click)="changeStatusUser()"
      *ngIf="(groupStatus === 'blocked' || (!userStatus && selectedUser.length === 0))"
      class="btn btn-accent">{{'USER_LIST.MODAL.UNBLOCKED_BUTTON' | translate}}</button>
    <button
      (click)="closeModal()"
      class="btn btn-light">{{'USER_LIST.MODAL.RESET_CANCEL' | translate}}</button>
  </div>
</div>
